import React from 'react';
import PropTypes from 'prop-types';
import { HotelHit } from '@bwoty-web/styleguide';
import { deviceWidths } from '@bwoty-web/styleguide/variables/widths';
import { getDeviceSources } from '../utils/imageUtils';

export const HotelHitAlgolia = (props) => {
  const { content, texts, imageDomain } = props;

  const mobileImageSize = { width: 253, height: 152 };
  const desktopImageSize = { width: 340, height: 340 };
  const deviceSpecs = [
    {
      size: mobileImageSize,
      mediaString: `(max-width: ${deviceWidths.tabletMax})`,
    },
    {
      size: desktopImageSize,
      mediaString: `(min-width: ${deviceWidths.tablet})`,
    },
  ];
  const { imageRelativeUrl } = content;
  const imgSources = getDeviceSources(deviceSpecs, imageDomain, imageRelativeUrl, null, null, 2);

  const tags = [];
  if (content?.isAdultHotel && texts?.adultFriendly) {
    tags.push({ text: texts?.adultFriendly, theme: 'adult' });
  } else if (content?.isFamilyHotel && texts?.childFriendly) {
    tags.push({ text: texts.childFriendly, theme: 'family' });
  }

  const imageContent = {
    picture: {
      fallback: {
        role: 'presentation',
        src: content?.image,
        srcSet: content?.image,
        alt: content?.name,
      },
      sources: imgSources,
    },
    concept: {
      name: content?.conceptImageClass,
    },
    tags,
  };

  const geographical = {
    resort: {
      name: content?.resort,
      href: null,
    },
    area: {
      name: content?.area,
      href: null,
    },
  };

  const filteredContent = {
    headerContent: {
      titleText: content?.name,
      geographical,
      link: {
        url: content?.url,
        target: '_blank',
      },
      rating: content?.rating * 2,
    },
    bodyContent: {
      uspList: content?.quickFacts,
      guestRating: content?.guestRating || null,
      tripAdvisor: {
        image: content?.tripAdvisor?.ratingImage,
        rating: content?.tripAdvisor?.averageRating,
      },
      texts: {
        guestRatingText: texts?.guestRatingResultLabel,
        tripAdvisorText: texts?.tripAdvisorText,
        mealsTexts: {
          packageDescriptionText: content?.boardCodeDescription,
          packageIncludedText: texts?.mealIncludedLabel,
          ancillaryText: null,
          ancillaryExtensionText: null,
        },
      },
    },
    footerContent: {
      texts: {
        buttonText: texts?.button,
        priceDetailsText: texts?.priceDetailsLinkText,
        packageInfoText: texts?.productsIncludedLabelFor,
        perPersonText: texts?.perPerson,
        noPriceText: texts?.noPriceLabel,
      },
      prices: {
        price: null,
        originalPrice: null,
        pricePerPerson: null,
      },
    },
  };

  return (
    <div className="web-result-hit">
      <HotelHit href={content?.url} imageContent={imageContent} content={filteredContent} />
    </div>
  );
};

HotelHitAlgolia.propTypes = {
  content: PropTypes.shape().isRequired,
  texts: PropTypes.shape().isRequired,
  imageDomain: PropTypes.string,
};
